import { TeamForFilter } from '../types';

export const getFilterOptions = (
  options: TeamForFilter[],
  searchValue: string,
): TeamForFilter[] =>
  options.filter((option) => {
    const lowerSearchValue = searchValue.toLowerCase();
    const matchName = option.name.toLowerCase().includes(lowerSearchValue);

    if (matchName) {
      // If the team's name matches, include the whole team
      return true;
    }

    const matchingUsers = option.users?.filter((user) => {
      const userNameMatch = user.userName
        .toLowerCase()
        .includes(lowerSearchValue);
      return userNameMatch;
    });

    if (matchingUsers && matchingUsers.length > 0) {
      // If any user within the team matches, include the team with matching users
      option.users = matchingUsers;
      return true;
    }

    // If neither the name nor any user within the team matches, exclude the team
    return false;
  });
